import { AppProvider, Avatar } from '@superops/ui-design-system';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const RecepientsWrapper = styled.div`
  width: 400px;
  padding: 8px;
  background: white;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.21);
  border-radius: 4px;
`;

const RecepientsHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Recepient = styled.div`
  background: rgba(0, 0, 0, 0.03);
  padding: 4px;
  margin-bottom: 4px;
  border-radius: 5px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Item = styled.div`
  height: 24px;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  align-items: center;
  background: #f2f5ff;
  border-radius: 12px;
  padding: 2px 8px 2px 1px;
`;

const recepientTemplate = (type, recepients, bubbleContainer = false) => {
  const typeMap = {
    to: 'TO',
    cc: 'CC',
    bcc: 'BCC',
    receivers: 'RECEIVERS'
  };
  return recepients?.length > 0 ? (
    <div className="flex center mb10">
      <div className="mr8">{`${typeMap[type]}:`}</div>
      <RecepientsHolder>
        {recepients.map((el) => {
          if (bubbleContainer) {
            return (
              <AppProvider i18n={{}}>
                <Item className="d-in-f ml-5">
                  <Avatar
                    name={el.user?.name || el.user?.email || ''}
                    initials={el.user?.name?.[0] || el.user?.email?.[0] || 'S'}
                    size="extraSmall"
                  />
                  <div className="ml-5">
                    {el.user?.name || el.user?.email || ''}
                  </div>
                </Item>
              </AppProvider>
            );
          }
          return (
            <Recepient key={el.userId || el.name} className="mr8">
              {el.user?.name || el.user?.email}
            </Recepient>
          );
        })}
      </RecepientsHolder>
    </div>
  ) : (
    ''
  );
};

function Recepients(props) {
  const { toUsers, ccUsers, bccUsers, receivers } = props.message;
  if (props.bubbleContainer) {
    return (
      <RecepientsWrapper>
        {toUsers && recepientTemplate('to', toUsers, true)}
        {ccUsers && recepientTemplate('cc', ccUsers, true)}
        {bccUsers && recepientTemplate('bcc', bccUsers, true)}
        {receivers && recepientTemplate('receivers', receivers, true)}
      </RecepientsWrapper>
    );
  }
  return (
    <RecepientsWrapper>
      {toUsers && recepientTemplate('to', toUsers)}
      {ccUsers && recepientTemplate('cc', ccUsers)}
      {bccUsers && recepientTemplate('bcc', bccUsers)}
      {receivers && recepientTemplate('receivers', receivers)}
    </RecepientsWrapper>
  );
}

export default Recepients;
